import { useState } from 'react';

const faqs = [
  {
    question: '国产一区平台主要提供什么类型的内容？',
    answer:
      '国产一区精选内容聚合平台汇聚了影视综娱、科技数码、生活百科、文学艺术、音乐天地、游戏动漫等八大分类的优质国产原创内容。我们精心筛选和整理每一篇内容，确保为您提供最全面、最优质的国产内容浏览体验。无论是热门推荐还是冷门珍藏，都能在这里找到。',
  },
  {
    question: '平台上的内容是免费浏览的吗？',
    answer:
      '是的，国产一区平台上的所有内容均为免费浏览。我们致力于打造一个开放、共享的国产原创内容聚合平台，让每一位用户都能无障碍地获取优质信息。无需注册，无需付费，随时随地畅享阅读。',
  },
  {
    question: '内容多久更新一次？',
    answer:
      '我们的编辑团队每日都会更新平台内容，确保您能够第一时间获取到最新的国产原创精选。同时，我们也会定期对历史内容进行梳理和优化，让经典内容焕发新的生命力。关注首页"最新精选"栏目，不错过任何精彩更新。',
  },
  {
    question: '如何快速找到我感兴趣的内容？',
    answer:
      '您可以通过首页的分类导航快速定位感兴趣的内容领域。我们提供了八大精选分类，每个分类下都有丰富的文章供您浏览。此外，您也可以使用页面顶部的导航栏在不同分类之间自由切换，轻松发现精彩内容。',
  },
  {
    question: '平台的国产原创内容来源是什么？',
    answer:
      '国产一区平台的内容来自国内优秀的原创作者和媒体机构。我们严格把控内容质量，所有收录的内容都经过编辑团队的审核和筛选，确保内容的原创性、真实性和可读性。我们致力于打造一个值得信赖的国产原创内容聚合平台。',
  },
  {
    question: '如何联系平台或提供内容合作？',
    answer:
      '如果您有内容合作意向或任何意见建议，欢迎通过"关于我们"页面中的联系方式与我们取得联系。我们非常重视每一位用户的反馈，也会认真考虑优质内容创作者的合作申请。期待与您共同打造更丰富的国产原创内容生态。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于国产一区平台的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm font-heading font-bold text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-foreground-400 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}